import { Node } from '@tiptap/core';

export const EditorColumn = Node.create({
    name: 'editorColumn',
    group: 'block',
    content: 'block+',
    defining: true,
    parseHTML: () => [{ tag: 'div[data-editor-column]' }],
    renderHTML: () => ['div', { 'data-editor-column': '' }, 0],
});

export const EditorColumns = Node.create({
    name: 'editorColumns',
    group: 'block',
    content: 'editorColumn{2,3}',
    defining: true,
    addAttributes() {
        return { count: { default: 2, parseHTML: element => Number(element.getAttribute('data-columns')) || 2 } };
    },
    parseHTML: () => [{ tag: 'div[data-editor-columns]' }],
    renderHTML: ({ HTMLAttributes }) => ['div', { 'data-editor-columns': '', 'data-columns': HTMLAttributes.count }, 0],
});
